import { ActividadesPlanificadas } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE'
import React, { useCallback, useEffect, useState } from 'react'
import { DetalleEstadosJornadaSolicitudHE, EstructuraOrganicaHEDTO, InformacionSolicitudHEServidor, JornadaLaboralSolicitadaHE, NroHorasRegimen, ParametrosSolicitudHE } from './TypesSolicitudPagoHE'
import { Table, Input, Button } from "reactstrap";
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import SelectItem2 from 'components/Varios/SelectNew';
import { SelectCombo } from 'components/Types/GeneralTypes';
import { showAlert, showAlertAviso } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';
import CustomTimePicker from 'components/Varios/TimePicker/CustomTimePicker';
import { EsMayorHora, EsMayorIgualHora, RestarHoras, SumarHoras, SumarHorasListado } from 'functions/TimeFunctions';
import { CalcularHorasSuplementariasYExtraordinarias } from './FunctionsSolicitudPagoHE';
import { FormGroup } from 'react-bootstrap';
import { useHistory } from 'react-router';


type PropsTablaSolicitudHE = {
    mesSolicitud: number,
    fechaActual: string,
    actividadesPlanificadas: ActividadesPlanificadas[],
    detalleJornada: JornadaLaboralSolicitadaHE[],
    estadosJornada: DetalleEstadosJornadaSolicitudHE[],
    estructuraSeleccionada: EstructuraOrganicaHEDTO | undefined,
    selectedDays: { [key: number]: JornadaLaboralSolicitadaHE },
    parametros: ParametrosSolicitudHE,
    informacionSolicitud: InformacionSolicitudHEServidor | null,
    guardarSolicitud: (selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }) => Promise<void>
    enviarFirmarSolicitud: (selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }) => Promise<void>
    onClickVerSolicitud: (informacion: InformacionSolicitudHEServidor) => Promise<void>
}



type ErrorJornada = {
    idJornada: number,
    error: string,
    idError: number
}

export function ObtenerOpcionesActividades(actividadesPlanificadas: ActividadesPlanificadas[], idUnidad: number) {
    var listadoOpciones: SelectCombo[] = [];
    if (actividadesPlanificadas.length > 0) {
        const filtrados = actividadesPlanificadas.filter((u) => u.idEstructura === idUnidad);

        listadoOpciones = filtrados.map((v, i) => { return { label: v.nombreActividad, value: v.idActividadPersona.toString() } })
    }

    return listadoOpciones;

}

export function GenerarListadoHorarios(horaInicio: string, horaFin: string): { label: string; value: string }[] {
    if(horaInicio == horaFin) {return []}
    // Convertir las horas a objetos Date
    const [horaInicioH, minutoInicioM] = horaInicio.split(':').map(Number);
    const [horaFinH, minutoFinM] = horaFin.split(':').map(Number);

    const inicio = new Date();
    inicio.setHours(horaInicioH, minutoInicioM + 1, 0, 0);

    const fin = new Date();
    fin.setHours(horaFinH, minutoFinM, 0, 0);

    // Validar que la hora de inicio no sea después de la hora de fin
    if (inicio > fin) {
        throw new Error("La hora de inicio debe ser menor o igual a la hora de fin");
    }

    const resultado: { label: string; value: string }[] = [];

    // Generar los valores en el rango
    let actual = new Date(inicio);
    while (actual <= fin) {
        const horas = actual.getHours().toString().padStart(2, '0');
        const minutos = actual.getMinutes().toString().padStart(2, '0');
        const valor = `${horas}:${minutos}`;
        resultado.push({ label: valor, value: valor });

        // Incrementar un minuto
        actual.setMinutes(actual.getMinutes() + 1);
    }

    return resultado;
}

export default function TablaSolicitudHE(props: PropsTablaSolicitudHE) {

    const {
        detalleJornada
    } = props

    const ERROR_MINIMO_MAXIMO = 1;
    const ERROR_TIEMPO_MIN = 2;
    const ERROR_VACIO = 3;


    const [currentRows, setcurrentRows] = useState<JornadaLaboralSolicitadaHE[]>([])
    const [selectedDays, setselectedDays] = useState<{ [key: number]: JornadaLaboralSolicitadaHE }>(props.selectedDays);
    const [errorHoraHasta, seterrorHoraHasta] = useState<string>("")
    const [erroresJornada, seterroresJornada] = useState<ErrorJornada[]>([])

    const history = useHistory();

    useEffect(() => {
        setcurrentRows(props.detalleJornada);
    }, [props.detalleJornada])

    useEffect(() => {
        if (props.detalleJornada.length > 0 && !props.informacionSolicitud) {
            // const copiaDiasJornada = [...props.detalleJornada];
            // var nuevaSeleccion = { ...selectedDays };

            // for (let index = 0; index < copiaDiasJornada.length; index++) {
            //     const diaJornada = copiaDiasJornada[index];
            //     nuevaSeleccion[diaJornada.idJornada] = {
            //         ...diaJornada
            //     }
            // }


            //setselectedDays(nuevaSeleccion)



        }
    }, [])




    // useEffect(() => {
    //     if(props.selectedDays){
    //         setselectedDays(props.selectedDays);
    //     }

    // }, [props.selectedDays])

    const handleSort = (column: string) => {
        // const isAsc = sortColumn === column && sortDirection === 'asc';
        // setSortColumn(column);
        // setSortDirection(isAsc ? 'desc' : 'asc');
        // setSortToggle(!sortToggle); 
    };

    const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        return
    }

    const preventClick = (event: React.MouseEvent<HTMLInputElement>) => {
        event.preventDefault(); // Evita que se dispare el evento de clic
    };




    const handleChange = useCallback((currentRows: JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE, valor: any, name: string) => {

        const indiceCambiar: number = currentRows.findIndex((v) => {
            const fecha = new Date(v.fecha);
            const fechaFilaActual = new Date(informacionDiaJornada.fecha);
            return fecha.getTime() === fechaFilaActual.getTime()
        })

        var copiaListadoActual = [...currentRows];

        const idJornadaFechas = copiaListadoActual[indiceCambiar].idJornada ?? 0;
        if (name === "planificadaS") {
            if (valor) {

                copiaListadoActual[indiceCambiar].planificada = "S";
                copiaListadoActual[indiceCambiar].actividad = "";
            }
            else {
                copiaListadoActual[indiceCambiar].planificada = null;
                copiaListadoActual[indiceCambiar].idPlanifActividadPersona = null;
                copiaListadoActual[indiceCambiar].idActividad = null;
            }


        }
        else if (name === "planificadaN") {
            if (valor) {

                copiaListadoActual[indiceCambiar].planificada = "N";
                copiaListadoActual[indiceCambiar].actividad = "";
                copiaListadoActual[indiceCambiar].idPlanifActividadPersona = null;
                copiaListadoActual[indiceCambiar].idActividad = null;
            }
            else {
                copiaListadoActual[indiceCambiar].planificada = null;
            }

        }
        else if (name === "actividadPlanificadaHE") {
            const opcion: SelectCombo = valor;
            //console.log(opcion)
            copiaListadoActual[indiceCambiar].idPlanifActividadPersona = +opcion.value;
            copiaListadoActual[indiceCambiar].actividad = opcion.label;
            //copiaListadoActual[indiceCambiar].idPlanifActividadPersona = informacionDiaJornada.idActividad;
        }
        else if (name === "actividadNoPlanificadaHE") {
            var texto: string = valor;
            if (texto) {
                texto = texto.toUpperCase();
            }
            copiaListadoActual[indiceCambiar].actividad = texto;
            copiaListadoActual[indiceCambiar].idPlanifActividadPersona = null;
        }
        else if (name === "horaextrahastausuario") {
            if (valor !== null && valor !== "" && copiaListadoActual[indiceCambiar].horaExtraDesde) {

                copiaListadoActual[indiceCambiar].horaExtraHastaUsuario = valor;
                const horasExtras = CalcularHorasSuplementariasYExtraordinarias(copiaListadoActual[indiceCambiar], props.parametros.timeHorasParaConsiderarSuplementarias, props.parametros.maxTimeSinRecesoFDS)
                copiaListadoActual[indiceCambiar].horaExtr = horasExtras.horasExtraordinarias;
                copiaListadoActual[indiceCambiar].horaSupl = horasExtras.horasSuplementarias;
                copiaListadoActual[indiceCambiar].totalHorasExtras = horasExtras.totalhoras;


                if (idJornadaFechas in selectedDays) {
                    var copiaSelectedDay = { ...selectedDays };
                    var copiaDiaSeleccionado = { ...selectedDays[idJornadaFechas] }

                    copiaDiaSeleccionado.horaExtraHastaUsuario = valor;
                    copiaDiaSeleccionado.horaExtr = horasExtras.horasExtraordinarias;
                    copiaDiaSeleccionado.horaSupl = horasExtras.horasSuplementarias;
                    copiaDiaSeleccionado.totalHorasExtras = horasExtras.totalhoras;


                    copiaSelectedDay[idJornadaFechas] = copiaDiaSeleccionado;

                    setselectedDays(copiaSelectedDay);
                }


            }
        }
        else if (name === "errorhoraextrausuario") {
            copiaListadoActual[indiceCambiar].errorHoraExtraUsuario = valor;
        }


        var copiaSelectedDay = { ...selectedDays };
        var copiaDiaSeleccionado = { ...selectedDays[idJornadaFechas] }
        var diaModificado = copiaListadoActual[indiceCambiar];
        copiaDiaSeleccionado = { ...diaModificado }


        if (name === "planificadaS" || name === "planificadaN") {
            if (valor === null) {
                copiaDiaSeleccionado.planificada = null;
                copiaDiaSeleccionado.actividad = null;
                copiaDiaSeleccionado.idActividad = null;
                const indiceElemento = currentRows.findIndex((v) => v.idJornada === diaModificado.idJornada)
                copiaListadoActual[indiceElemento] = copiaDiaSeleccionado;
                delete copiaSelectedDay[diaModificado.idJornada];
            }
            else {
                copiaSelectedDay[informacionDiaJornada.idJornada] = {
                    ...copiaDiaSeleccionado
                }
            }

            setselectedDays(copiaSelectedDay);
        }
        else if (idJornadaFechas in selectedDays) {
            copiaSelectedDay[idJornadaFechas] = copiaDiaSeleccionado;
            setselectedDays(copiaSelectedDay);
        }

        setcurrentRows(copiaListadoActual);
    }, [selectedDays])

    //const validateonChangeTime = (currentRows:  JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE, newValue: string | null) => {
    const validateonChangeTime = (currentRows: JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE, newValue: string | null, erroresJornada: ErrorJornada[]) => {
        const minimo: string | null = informacionDiaJornada.horaExtraDesde
        const maximo: string | null = informacionDiaJornada.horaExtraHasta
        var mensajeError: string = ""
        var copiaErrores = [...erroresJornada]
        if (newValue === null || newValue === "") {
            mensajeError = "La hora no puede ser vacía"
            //showAlert(mensajeError, false);

            seterroresJornada([...erroresJornada, {
                error: mensajeError,
                idJornada: informacionDiaJornada.idJornada,
                idError: ERROR_VACIO
            }])
            //seterrorHoraHasta(mensajeError)
            //return false;
        }
        else {
            if (minimo && maximo) {
                const fechaActual = new Date()

                const [hnew, mnew] = newValue.split(":")
                const [hmin, mmin] = minimo.split(":")
                const [hmax, mmax] = maximo.split(":")



                const newfechavalue = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), +hnew, +mnew, 0);
                const fechaMinima = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), +hmin, +mmin, 0);
                const fechaMaxima = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate(), +hmax, +mmax, 0);

                if (newfechavalue.getTime() < fechaMinima.getTime() || fechaMaxima.getTime() < newfechavalue.getTime()) {
                    mensajeError = "La hora para ese día no puede ser menor a " + minimo + " ni mayor a " + maximo
                    //showAlertAviso(mensajeError);
                    //seterrorHoraHasta(mensajeError)

                    copiaErrores = [...copiaErrores, {
                        error: mensajeError,
                        idJornada: informacionDiaJornada.idJornada,
                        idError: ERROR_MINIMO_MAXIMO
                    }]

                    // seterroresJornada([...erroresJornada, {
                    //     error: mensajeError,
                    //     idJornada: informacionDiaJornada.idJornada
                    // }])


                    //return false;
                }
                else {

                    const jornadaStateTieneElError = erroresJornada.find((v) => v.idJornada === informacionDiaJornada.idJornada && v.idError === ERROR_MINIMO_MAXIMO) !== undefined
                    if (jornadaStateTieneElError) {
                        copiaErrores = [...copiaErrores.filter((v) => v.idJornada !== informacionDiaJornada.idJornada)]
                    }
                }


            }

            const copiaInformacionJornada = { ...informacionDiaJornada, horaExtraHastaUsuario: newValue }
            const horasExtras = CalcularHorasSuplementariasYExtraordinarias(copiaInformacionJornada, props.parametros.timeHorasParaConsiderarSuplementarias, props.parametros.maxTimeSinRecesoFDS)



            // if (!EsMayorIgualHora(horasExtras.totalhoras, props.parametros.timeMinimoMinutos)) {

            //     const [textoHoras, textoMinutos] = horasExtras.totalhoras.split(":")
            //     const [textoMinimoHoras, textoMinimoMinutos] = props.parametros.timeMinimoMinutos.split(":")

            //     const diferenciaUsuario = RestarHoras(copiaInformacionJornada.horaExtraDesde ?? "00:00", copiaInformacionJornada.horaExtraHastaUsuario);
            //     const [diferenciaHoras, diferenciaMinutos] = diferenciaUsuario.split(":")


            //     //mensajeError = `Ud está seleccionando un tiempo igual a ${diferenciaHoras}h:${diferenciaMinutos}m , pero el tiempo mínimo para solicitar Horas Extras es de ${textoMinimoHoras}h:${textoMinimoMinutos}m`

            //     mensajeError = `El tiempo mínimo para solicitar Horas Extras es de ${textoMinimoHoras}h:${textoMinimoMinutos}m`




            //     copiaErrores = [...copiaErrores, {
            //         error: mensajeError,
            //         idJornada: informacionDiaJornada.idJornada,
            //         idError: ERROR_TIEMPO_MIN
            //     }]


            // }
            // else {

            //     const jornadaStateTieneElError = erroresJornada.find((v) => v.idJornada === informacionDiaJornada.idJornada && v.idError === ERROR_TIEMPO_MIN) !== undefined
            //     if (jornadaStateTieneElError) {
            //         copiaErrores = [...copiaErrores.filter((v) => v.idJornada !== informacionDiaJornada.idJornada)]
            //     }
            // }



        }

        seterroresJornada(copiaErrores)

        // if(mensajeError === "" && erroresJornada.find((v) => v.idJornada === informacionDiaJornada.idJornada) !== undefined){

        //     copiaErrores = [... erroresJornada.filter((v) => v.idJornada !== informacionDiaJornada.idJornada)]

        //     seterroresJornada(copiaErrores)


        // }
        handleChange(currentRows, informacionDiaJornada, newValue, "horaextrahastausuario")

    }

    const allSelected = currentRows.every((serv) => selectedDays[serv.idJornada]);


    const handleSelectOne = (diaJornada: JornadaLaboralSolicitadaHE, selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }, currentRows: JornadaLaboralSolicitadaHE[]) => {

        var nuevaSeleccion = selectedDays === undefined ? {} : { ...selectedDays }
        var copiaCurrentRows = [...currentRows]
        var copiaDiaJornada = { ...diaJornada }
        var cambio = false;
        const seEncuentraSeleccionado: boolean = nuevaSeleccion[diaJornada.idJornada] !== undefined;
        const parametroDeHorasMaximas: NroHorasRegimen = props.parametros.horas[0];


        if (seEncuentraSeleccionado) {

            copiaDiaJornada.planificada = null;
            copiaDiaJornada.actividad = null;
            copiaDiaJornada.idActividad = null;


            const indiceElemento = currentRows.findIndex((v) => v.idJornada === diaJornada.idJornada)

            copiaCurrentRows[indiceElemento] = copiaDiaJornada;

            cambio = true;

            delete nuevaSeleccion[diaJornada.idJornada];
        }
        else {

            var totalHorasExtras = "";
            for (const key in nuevaSeleccion) {
                if (nuevaSeleccion.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                    const jornada = nuevaSeleccion[Number(key)]; // Convertir la clave a número
                    if (jornada.totalHorasExtras) {
                        totalHorasExtras = SumarHoras(totalHorasExtras, jornada.totalHorasExtras);
                    }
                }
            }

            if (diaJornada.totalHorasExtras) {
                const nuevoTotalHorasExtras = SumarHoras(totalHorasExtras, diaJornada.totalHorasExtras)


                const maximoDeHoras: string = `${parametroDeHorasMaximas.horasTotal}:00`

                // if (EsMayorHora(nuevoTotalHorasExtras, maximoDeHoras)) {
                //     showAlertAviso(`El total de horas laboradas supera el máximo de horas extras permitidas (${maximoDeHoras}). Por favor modifique su solicitud`)
                // }
                // else {
                //     nuevaSeleccion[diaJornada.idJornada] = {
                //         ...diaJornada
                //     }
                // }
                nuevaSeleccion[diaJornada.idJornada] = {
                    ...diaJornada
                }


            }

        }


        setselectedDays(nuevaSeleccion)
        if (cambio) {
            setcurrentRows(copiaCurrentRows)
        }

    }

    const handleSelectAll = (currentRows: JornadaLaboralSolicitadaHE[], selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }) => {

        let newSelection = { ...selectedDays }

        const isAllSelected = currentRows.every((serv) => selectedDays[serv.idJornada]);
        var copiaCurrentRows = [...currentRows]
        var cambio: boolean = false;
        if (isAllSelected) {
            for (let index = 0; index < currentRows.length; index++) {
                var jornada = currentRows[index];

                delete newSelection[jornada.idJornada]


                jornada.planificada = null;
                jornada.actividad = null;
                jornada.idActividad = null;


                const indiceElemento = currentRows.findIndex((v) => v.idJornada === jornada.idJornada)

                copiaCurrentRows[indiceElemento] = jornada;
                cambio = true;
            }

        }
        else {
            for (let index = 0; index < currentRows.length; index++) {
                const jornada = currentRows[index];
                if (!((jornada.idActividad ?? 0) in selectedDays)) {
                    newSelection[jornada.idJornada] = {
                        ...jornada
                    }
                }
            }
        }


        setselectedDays(newSelection)
        if (cambio) {
            setcurrentRows(copiaCurrentRows)
        }
    }

    const ValidarEnvioGuardadoSolicitud = (selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }, erroresJornada: ErrorJornada[], tipo: "GU" | "FI") => {


        const [anio, mes, dia] = props.fechaActual.split("T")[0].split("-");
        const fechaActual = new Date(+anio, +mes - 1, +dia, 0, 0, 0);




        const parametroDeHorasMaximas: NroHorasRegimen = props.parametros.horas[0];
        const maximoDeHoras: string = `${parametroDeHorasMaximas.horasTotal}:00`





        var totalHorasSuplementarias: string = "";
        var totalHorasExtraordinarias: string = "";
        var totalHorasExtras: string = "";

        var faltaActividad: boolean = false;

        const diaMaximoParaSolicitarDiciembre = 16

        if (props.mesSolicitud !== 12) {
            if (+dia > props.parametros.maximoDiaRecepcion) {
                showAlertAviso("El día máximo para envío de solicitudes de horas extras es el " + props.parametros.maximoDiaRecepcion + " del presente mes");
                return false;
            }
        }
        else {
            if (+dia > diaMaximoParaSolicitarDiciembre) {
                showAlertAviso("El día máximo para envío de solicitudes de horas extras es el " + diaMaximoParaSolicitarDiciembre + " del presente mes");
                return false;
            }
        }





        for (const key in selectedDays) {
            if (selectedDays.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                const jornada = selectedDays[Number(key)]; // Convertir la clave a número

                if (jornada.horaExtr) {
                    totalHorasExtraordinarias = SumarHoras(totalHorasExtraordinarias, jornada.horaExtr);
                }

                if (jornada.horaSupl) {
                    totalHorasSuplementarias = SumarHoras(totalHorasSuplementarias, jornada.horaSupl);
                }

                if (!jornada.actividad) {
                    faltaActividad = true;
                }

            }
        }

        const maximoDeHorasExtraordinarias: string = `${parametroDeHorasMaximas.horasExtraordinarias}:00`
        const maximoDeHorasSuplementarias: string = `${parametroDeHorasMaximas.horasSuplementarias}:00`

        totalHorasExtras = SumarHoras(totalHorasSuplementarias, totalHorasExtraordinarias);

        //if(props.fechaActual.)


        if (parametroDeHorasMaximas.horasSuplyExtr === null) {
            if (parametroDeHorasMaximas.horasExtraordinarias !== null && EsMayorHora(totalHorasExtraordinarias, maximoDeHorasExtraordinarias)) {
                showAlertAviso(`El total de horas laboradas supera el máximo de horas extras EXTRAORDINARIAS permitidas (${maximoDeHorasExtraordinarias.split(":")[0]}). Por favor, modifique su solicitud`)
                return false;
            }
            if (parametroDeHorasMaximas.horasSuplementarias !== null && EsMayorHora(totalHorasSuplementarias, maximoDeHorasSuplementarias)) {
                showAlertAviso(`El total de horas laboradas supera el máximo de horas extras SUPLEMENTARIAS permitidas (${maximoDeHorasSuplementarias.split(":")[0]}). Por favor, modifique su solicitud`)
                return false;
            }
        }

        if (EsMayorHora(totalHorasExtras, maximoDeHoras)) {
            showAlertAviso(`El total de horas laboradas supera el máximo de horas extras permitidas (${maximoDeHoras.split(":")[0]}). Por favor, modifique su solicitud`)
            return false;
        }
        else if (faltaActividad && tipo === "FI") {
            showAlertAviso(`Tiene días seleccionados en los que no se han indicado las actividades realizadas. Por favor, complete la información`)
            return false;
        }

        if (erroresJornada.length > 0) {
            showAlertAviso("Tiene días seleccionados que reflejan errores. Por favor, modifique su solicitud")
            return false;
        }




        return true;
    }

    const HandleClickGuardar = (selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }, erroresJornada: ErrorJornada[]) => {
        const puedeRealizarAccion = ValidarEnvioGuardadoSolicitud(selectedDays, erroresJornada, "GU");
        if (puedeRealizarAccion) {
            props.guardarSolicitud(selectedDays);
        }

    }

    const HandleClickEnviarFirmar = (selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }, erroresJornada: ErrorJornada[]) => {
        const puedeRealizarAccion = ValidarEnvioGuardadoSolicitud(selectedDays, erroresJornada, "FI");
        if (puedeRealizarAccion) {
            props.enviarFirmarSolicitud(selectedDays);
        }

    }

    

    function TdsPlanificadasImprevistas(i: number, currentRows: JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE, selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }) {


        if (!informacionDiaJornada.puedeSolicitarHorasExtras) {
            return (
                <>
                    <td />
                    <td />
                </>
            )
        }
        else if (props.estructuraSeleccionada && !props.estructuraSeleccionada.unidadPlanificada) {
            return (
                <>
                    <td className="tdPlanificada" style={{ textAlign: "center" }}>
                        <Input onClick={preventClick} onChange={handleOptionChange} className="checkRadioRegimenNroHorasExtras" type="radio" defaultChecked={false} name={"planificadaS" + i} ></Input>
                    </td>
                    <td className="tdImprevista" style={{ textAlign: "center" }}>
                        <Input onClick={preventClick} onChange={handleOptionChange} className="checkRadioRegimenNroHorasExtras" type="radio" defaultChecked={true} name={"planificadaN" + i} ></Input>
                    </td>
                </>
            )
        }
        else {


            return (
                <>
                    <td className="tdPlanificada" style={{ textAlign: "center" }}>
                        <Input
                            onClick={() => {
                                if (informacionDiaJornada.planificada === "S") {
                                    handleChange(currentRows, informacionDiaJornada, null, "planificadaS");
                                }
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                //(informacionDiaJornada, selectedDays, currentRows)
                                handleChange(currentRows, informacionDiaJornada, e.target.checked, "planificadaS")
                            }}
                            className="checkRadioRegimenNroHorasExtras"
                            type="radio"
                            checked={informacionDiaJornada.planificada === null ? false : informacionDiaJornada.planificada === "S"}
                            name={"planificadaS" + i}
                            id={"idplanificadaS" + i}
                        />
                    </td>
                    <td className="tdImprevista" style={{ textAlign: "center" }}>
                        <Input
                            onClick={() => {
                                if (informacionDiaJornada.planificada === "N") {
                                    handleChange(currentRows, informacionDiaJornada, null, "planificadaN");
                                }
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                //handleSelectOne(informacionDiaJornada, selectedDays, currentRows)
                                handleChange(currentRows, informacionDiaJornada, e.target.checked, "planificadaN")
                            }}
                            className="checkRadioRegimenNroHorasExtras"
                            type="radio"
                            checked={informacionDiaJornada.planificada === null ? false : informacionDiaJornada.planificada === "N"}
                            name={"planificadaN" + i}
                            id={"idplanificadaN" + i}
                        />
                    </td>
                </>
            )
        }

    }

    function TdDescripcionActividad(i: number, currentRows: JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE) {

        if (!informacionDiaJornada.puedeSolicitarHorasExtras) {
            return (
                <td />
            )
        }
        else if (informacionDiaJornada.planificada === "S" && props.estructuraSeleccionada) {
            return (
                <td>
                    <SelectItem2
                        options={ObtenerOpcionesActividades(props.actividadesPlanificadas, props.estructuraSeleccionada.idEstructuraOrganica)}
                        placeholder=""
                        name={"actividadPlanificadaHE" + i}
                        id={"actividadPlanificadaHE" + i}
                        icon="fa-caret-down"
                        value={informacionDiaJornada.idPlanifActividadPersona ?? 0}
                        onChange={(value, name, tipo, label) => handleChange(currentRows, informacionDiaJornada, {
                            label,
                            value
                        }, "actividadPlanificadaHE")}
                        isSearchable = {false}
                    // disabled = {!props.informacionSolicitud?.puedeSolicitar}
                    />
                </td>
            )
        }
        else if (informacionDiaJornada.planificada === null) {
            return (
                <td>

                </td>
            )
        }
        else {
            return (
                <td>
                    {/* <Input type="text" className="inputActividadHE" value={informacionDiaJornada.actividad} onChange={(e) => handleChange(currentRows, informacionDiaJornada, e.target.value, "actividadNoPlanificadaHE")} /> */}
                    <FormGroup>
                        <Input
                            id={"actividad" + i}
                            name={"actividadName" + i}
                            maxLength="200"
                            className="inputActividadHE"
                            type="textarea"
                            placeholder="Máximo 200 caracteres"
                            value={informacionDiaJornada.actividad ?? ""}
                            onChange={(e) => handleChange(currentRows, informacionDiaJornada, e.target.value, "actividadNoPlanificadaHE")}
                        />
                        {/* <div className="text-muted text-right">
                            {informacionDiaJornada.actividad !== null ? informacionDiaJornada.actividad.length: 0}/{200}
                        </div> */}
                    </FormGroup>

                </td>
            )

        }
    }

    

    const SelectTime = (informacionDiaJornada: JornadaLaboralSolicitadaHE, currentRows: JornadaLaboralSolicitadaHE[], erroresJornada: ErrorJornada[], diaSeleccionado:boolean) => {

        const listadoOpciones: SelectCombo[] = GenerarListadoHorarios(informacionDiaJornada.horaExtraDesde ?? "00:00", informacionDiaJornada.horaSalida);


        const select = <SelectItem2
            options={listadoOpciones}
            placeholder=""
            name={"opcionHoraExtraHasta " + informacionDiaJornada.idJornada}
            id={"regimenLaboral " + informacionDiaJornada.idJornada}
            icon="fa-clock"
            classNameIcon="icon-inside-select-clock"
            value={informacionDiaJornada.horaExtraHastaUsuario}
            onChange={(v, n, t, l) => validateonChangeTime(currentRows, informacionDiaJornada, v, erroresJornada)}
            center={true}
            disabled = {!diaSeleccionado}
        />

        return select;
    }

    function TdHoraExtraHasta(i: number, currentRows: JornadaLaboralSolicitadaHE[], informacionDiaJornada: JornadaLaboralSolicitadaHE, erroresJornada: ErrorJornada[],diaSeleccionado:boolean) {
        if (informacionDiaJornada.horaExtraHastaUsuario) {



            return (
                <td className='tdHastaHoraExtra'>

                    <div>

                        {/* <Input type="time" className="inputTime"
                            value={informacionDiaJornada.horaExtraHastaUsuario}
                            //onChange={(e) => handleChange(currentRows, informacionDiaJornada, e.target.value, "horaextrahastausuario")}
                            onChange={(e) => validateonChangeTime(currentRows, informacionDiaJornada, e.target.value, erroresJornada)}

                        /> */}

                        {
                            SelectTime(informacionDiaJornada, currentRows, erroresJornada,diaSeleccionado)
                        }

                        <small className='small-error'> {erroresJornada.find((v) => v.idJornada === informacionDiaJornada.idJornada)?.error} </small>


                    </div>

                </td>
            )
        }
        else {
            return <td className='tdHastaHoraExtra'>{informacionDiaJornada.horaExtraHastaUsuario}</td>
        }
    }

    function TBodyTablaSolicitudHE(currentRows: JornadaLaboralSolicitadaHE[], selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }, erroresJornada: ErrorJornada[]) {
        const filas = currentRows.map((v, i) => {

            const diaSeleccionado:boolean  = selectedDays[v.idJornada] !== undefined;
            


            return (
                <React.Fragment key={"filasJornadaServidorHE" + i}>
                    <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE rowsSolicPagoHe'>
                        <td className='centrado tddia'>
                            {ObtenerFechaFromIsoFormat(v.fecha)}
                        </td>
                        <td className="tdFinSemana">
                            <div className="containerCheckFDSHE">
                                {
                                    v.finSemanaFeriado === "S" ? "SI" : "NO"
                                }
                                {/* <div className='containerContentCheck'>
                                    <div>SI</div>
                                    <Input onClick={preventClick} onChange={handleOptionChange} className="checkRadioRegimenNroHorasExtras" type="radio" defaultChecked={v.finSemanaFeriado === "S"} name={"checkFinSemanaFeriadoS" + i} ></Input>
                                </div>
                                <div className='containerContentCheck'>
                                    <div>NO</div>
                                    <Input onClick={preventClick} onChange={handleOptionChange} className="checkRadioRegimenNroHorasExtras" type="radio" defaultChecked={v.finSemanaFeriado !== "S"} name={"checkFinSemanaFeriadoN" + i} ></Input>
                                </div> */}

                            </div>
                        </td>
                        {
                            TdsPlanificadasImprevistas(i, currentRows, v, selectedDays)
                        }
                        {
                            TdDescripcionActividad(i, currentRows, v)
                        }
                        <td className='centrado tdEstadoReceso'>   {v.finSemanaFeriado === "S" ? "" : v.estadoReceso}</td>
                        <td className='centrado tdEstadoLabores'> {v.finSemanaFeriado === "S" ? "" : v.estadoLabores} </td>

                        <td className='centrado tdEntrada'>{v.horarioEntrada}</td>
                        <td className='centrado tdSalida'>{v.horarioSalida}</td>


                        <td className='centrado tdEntrada'>{v.horaEntrada}</td>
                        <td className='centrado tdSalida'>{v.horaSalida}</td>
                        <td className='centrado tdHExtraDesde'>{v.horaExtraDesde}</td>
                        {
                            TdHoraExtraHasta(i, currentRows, v, erroresJornada,diaSeleccionado)
                        }
                        <td className='centrado tdSup'>{v.horaSupl}</td>
                        <td className='centrado tdExt'>{v.horaExtr}</td>
                        {/* <td className="centrado">
                            {
                                v.puedeSolicitarHorasExtras &&
                                <input
                                    type="checkbox"
                                    //disabled = {v.idPlanifActividadPersona === null && (v.actividad === "" || v.actividad === null || v.actividad === undefined )}
                                    disabled={!(!props.informacionSolicitud || ["GU", "ND", "NT"].includes(props.informacionSolicitud.estado ?? ""))}
                                    id={"selectDiaHorasExtrasCheck" + i}
                                    name={"selectDiaHorasExtras" + i}
                                    checked={!!selectedDays[v.idJornada]}
                                    onChange={() => handleSelectOne(v, selectedDays, currentRows)}
                                    title='Seleccionar servidor'
                                />
                            }

                        </td> */}
                    </tr>
                </React.Fragment>
            )
        })

        return filas;


    }

    function TFooterTablaSolicitudHE(currentRows: JornadaLaboralSolicitadaHE[], selectedDays: { [key: number]: JornadaLaboralSolicitadaHE }) {

        // const horasSuplementarias:string[] = [];
        // const horasExtraOrdinarias:string[] = [];
        // const totalhorasSuplementarias:

        var totalHorasSuplementarias: string = "";
        var totalHorasExtraordinarias: string = "";
        var totalHorasExtras: string = "";
        for (const key in selectedDays) {
            if (selectedDays.hasOwnProperty(key)) { // Verificar que la propiedad es del objeto
                const jornada = selectedDays[Number(key)]; // Convertir la clave a número

                if (jornada.horaExtr) {
                    totalHorasExtraordinarias = SumarHoras(totalHorasExtraordinarias, jornada.horaExtr);
                }

                if (jornada.horaSupl) {
                    totalHorasSuplementarias = SumarHoras(totalHorasSuplementarias, jornada.horaSupl);
                }

            }
        }

        totalHorasExtras = SumarHoras(totalHorasSuplementarias, totalHorasExtraordinarias);

        return (
            <>
                <tr>
                    <td colSpan={8}>
                        <div className="containerSiglasEstadosJornada">
                            {
                                props.estadosJornada.map((v, i) => {
                                    return (
                                        <div className="itemSiglasEstadosJornada" key={"siglasEstadosJornada " + i}>
                                            <div >
                                                <strong>{v.siglas} :</strong> {v.descripcion}
                                            </div>
                                        </div>

                                    )
                                })
                            }
                            <div>
                                <div>
                                    <strong>{"P"} :</strong> {"Planificada"} / <strong>{"I"} :</strong> {"Imprevista"}
                                </div>
                            </div>
                        </div>

                    </td>

                    <td colSpan={5} style={{ textAlign: "right" }}>
                        <div> TOTAL HORAS EXTRAS SOLICITADAS:</div>
                    </td>
                    <td style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasSuplementarias}</td>
                    <td style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasExtraordinarias}</td>
                    {/* <td /> */}

                </tr>
                <tr >
                    <td colSpan={13}>{}</td>
                    <td colSpan={2 } style={{ textAlign: "center", border: "1px solid black" }}>{totalHorasExtras}</td>
                </tr>
            </>

        )

    }

    async function OnClickVerDocumento(informacionSolicitud: InformacionSolicitudHEServidor | null) {

        if (!informacionSolicitud) {
            return;
        }
        else {
            await props.onClickVerSolicitud(informacionSolicitud)
        }
    }

    function OnClickVerSolicitudes() {
        history.push({
            pathname: '/web/horasextras/'
        });
    }

    return (
        <>
            <Table className="table_solicitud_he">
                <thead className="cabeceras_tabla_solicitud_pago_he" >
                    <tr className="">
                        <th className="firstColumn" rowSpan={2} onClick={() => handleSort('dia')}>Día</th>
                        <th rowSpan={2} onClick={() => handleSort('finsemanafestivo')}>
                            <span>Sab.</span> <br />
                            <span>Dom. </span> <br />
                            <span>Fest.</span>

                        </th>
                        <th colSpan={2} onClick={() => handleSort('')}>
                            Tipo Actividad
                        </th>
                        <th rowSpan={2} onClick={() => handleSort('actividades')}>
                            Actividades
                        </th>
                        <th className='thEstados' colSpan={2} onClick={() => handleSort('')}>
                            Estados
                        </th>
                        <th className='thEstados' colSpan={2} onClick={() => handleSort('')}>
                            Horario
                        </th>
                        <th className="thHorasLaboradasSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Laboradas
                        </th>
                        <th className="thHorasAdicionalesSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Adicionales
                        </th>
                        <th className="thHorasExtrasSolicPagoHE" colSpan={2} onClick={() => handleSort('')}>
                            Horas Extras
                        </th>
                        {/* <th rowSpan={2} className="thAcciones" >Seleccionar <input type="checkbox" checked={allSelected} onChange={() => handleSelectAll(currentRows, selectedDays)} title='Seleccionar todos' /></th> */}
                    </tr>
                    <tr>
                        <th className={"thplanificada"}>P</th>
                        <th className={"thimprevista"}>I</th>
                        <th>Receso</th>
                        <th className='thLabores'>Labores</th>
                        <th>H. Entr</th>
                        <th className='thSalida'>H. Sali</th>
                        <th>Entrada</th>
                        <th className='thSalida'>Salida</th>
                        <th>Desde</th>
                        <th className='thHasta'>Hasta</th>
                        <th>Sup.</th>
                        <th className='thHExt'>Ext</th>

                    </tr>
                </thead>
                <tbody className="tbodysolicitudpagohe">
                    {TBodyTablaSolicitudHE(currentRows, selectedDays, erroresJornada)}
                </tbody>
                <tfoot className="tfootersolicitudpagohe">
                    {TFooterTablaSolicitudHE(currentRows, selectedDays)}
                </tfoot>

            </Table>
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                {
                    props.informacionSolicitud !== null && !["GU","ND","NT","RV"].includes(props.informacionSolicitud.estado.trim()) &&
                    <Button onClick={() => OnClickVerDocumento(props.informacionSolicitud)} className="button-he-secondary">Ver solicitud</Button>

                }
                {/* className="btn-backlightblue" */}
                {/* <Button onClick={() => OnClickVerSolicitudes()} className="button-he-primary" >VER SOLICITUDES</Button> */}
                <Button className="button-he-secondary" disabled={(props.informacionSolicitud !== null && !props.informacionSolicitud.puedeSolicitar) || Object.keys(selectedDays).length === 0} onClick={() => HandleClickGuardar(selectedDays, erroresJornada)} >GUARDAR</Button>
                <Button className="button-he-primary" disabled={(props.informacionSolicitud !== null && !props.informacionSolicitud.puedeSolicitar) || Object.keys(selectedDays).length === 0} onClick={() => HandleClickEnviarFirmar(selectedDays, erroresJornada)}  >FIRMAR Y ENVIAR A DIRECTIVO</Button>


            </div>
        </>

    )
}
